import {useState} from 'react';
import {useAuth} from './auth';
import {Notice} from './components';

export function Login() {
  const {signIn, finishMfa, pendingMfa, error} = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);

  return <main className="login-shell">
    <section className="login-card">
      <div className="brand-mark">GD</div>
      <p className="eyebrow">Goat Deeper</p>
      <h1>Utilisateurs et accès</h1>
      <p className="lede">Gérez les profils, les périmètres et leur historique depuis un compte Firebase existant.</p>
      {error && <Notice tone="danger">{error}</Notice>}
      {!pendingMfa ? <form onSubmit={async event => {
        event.preventDefault(); setBusy(true);
        try { await signIn(email, password); } catch { /* Message shown by context. */ } finally { setBusy(false); }
      }}>
        <label>Adresse e-mail<input type="email" autoComplete="username" value={email} onChange={event => setEmail(event.target.value)} required autoFocus /></label>
        <label>Mot de passe<input type="password" autoComplete="current-password" value={password} onChange={event => setPassword(event.target.value)} required /></label>
        <button className="primary full" disabled={busy}>{busy ? 'Connexion…' : 'Se connecter'}</button>
      </form> : <form onSubmit={async event => {
        event.preventDefault(); setBusy(true);
        try { await finishMfa(code); } catch { /* Message shown by context. */ } finally { setBusy(false); }
      }}>
        <Notice>Un code a été envoyé vers <strong>{pendingMfa.phoneLabel}</strong>.</Notice>
        <label>Code de vérification<input inputMode="numeric" autoComplete="one-time-code" value={code} onChange={event => setCode(event.target.value)} required autoFocus /></label>
        <button className="primary full" disabled={busy}>{busy ? 'Vérification…' : 'Vérifier le code'}</button>
      </form>}
      <p className="security-note">Les mutations exigent un e-mail vérifié et une authentification de moins de cinq minutes.</p>
    </section>
  </main>;
}
